export const AIRTABLE_CONNECTION_ID: string = 'AIRTABLE_CONNECTION_ID'
export const GOOGLE_FORM_CONNECTION_ID: string = 'GOOGLE_FORM_CONNECTION_ID'
export const GOOGLE_SEARCH_CONNECTION_ID: string = 'GOOGLE_SEARCH_CONNECTION_ID'
export const GOOGLE_ADD_SITEMAP_URL: string = 'GOOGLE_ADD_SITEMAP_URL'
